import { render } from "./BrandRadioContentAustria.vue?vue&type=template&id=dce58b2a"
import script from "./BrandRadioContentAustria.vue?vue&type=script&lang=ts"
export * from "./BrandRadioContentAustria.vue?vue&type=script&lang=ts"

import "./BrandRadioContentAustria.vue?vue&type=style&index=0&id=dce58b2a&lang=scss"
script.render = render

export default script